module.exports = __webpack_public_path__ + "5a58e090b5d7e35ffc25700abc76828d.svg";